<template>
  <div class="d-block d-sm-inline-block">
    <div class="d-block d-sm-inline-block">
      <label class="mt-2" for="year">ปี:</label>
    </div>
    <div class="d-block d-sm-inline-block input my-2 my-sm-0 mx-sm-2">
      <v-select
        id="year"
        :items="years"
        v-model="year"
        item-text="text"
        item-value="value"
        outlined
        dense
        hide-details/>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      year: 2000,
      years: [],
    }
  },
  props: {
    value: { types: Number, require: true }
  },
  mounted() {
    this.year = this.value
    this.genYears()
  },
  watch: {
    year (newVal, oldVal) {
      if (newVal !== oldVal) this.$emit('input', newVal)
    },
    value (newVal) {
      this.year = newVal
    },
  },
  methods: {
    genYears() {
      if (!this.promotions) {
        let year = moment().year()
        this.years = [
          { text: year + 543, value: year }
        ]
        return
      }
      const data = this.promotions.reduce((result, item) => {
        const start = moment(item.StartDate__c).year()
        result.min = result.min === null || result.min > start? start: result.min
        const end = moment(item.EndDate__c).year()
        result.max = result.max === null || result.max < end? end: result.max
        return result
      }, { min: null, max: null })
      for(let i = data.min; i <= data.max; i++) {
        this.years.push({ text: i + 543, value: i })
      }
    },
  },
  computed: {
    ...mapGetters({
      promotions: 'Calendar/getPromotions',
    }),
  }
}
</script>